import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { API } from "aws-amplify";
import { Card, Layout, Row, Spin, Button, Tabs, Descriptions, Table, Col } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import { useSelector } from "react-redux";

const { Header, Content } = Layout;
const ButtonGroup = Button.Group;

const ItemActionsSnapshot = () => {
  const history = useHistory();
  const { hotelId } = useParams();

  const [loading, setLoading] = useState(false);
  const [snapped, setSnapped] = useState(false);
  const [hotelName, setHotelName] = useState('');

  useEffect(() => {
    switch (hotelId) {
      case '1':
        setHotelName("- Hacienda del Indio");
        break;
      case '2':
        setHotelName("- Motel Las Fuentes");
        break;
      case '3':
        setHotelName("- Motel El Cortijo");
        break;
      default:
        setHotelName("");
        break;
    }
  }, [hotelId]);

  const getSnapshot = async () => {
    setLoading(true);

    return await API.post(
      "benackoAPI",
      "/v2/reports/inventories/balances/snapshot",
      {body: {hotelId}}
    ).catch((err) => console.log("Error triggering snapshot", err))
    .finally(() => {
      setSnapped(true);
      setLoading(false);
    });
  };

  return (
    <Layout>
      <Header style={{ background: "#fff", padding: 0 }}>
        <Row>
          <ButtonGroup>
            <Button type="primary" onClick={() => history.goBack()}>
              <LeftOutlined />
              Regresar
            </Button>
          </ButtonGroup>
        </Row>
      </Header>
      <Content style={{ margin: 0, padding: 0, background: "#fff" }}>
        <Spin spinning={loading} size="large">
          <Card
            bordered={false}
            title={"Crear captura de inventarios " + hotelName}
          ></Card>
          <Row style={{ marginTop: 40 }}>
              <Col span={20} offset={2}>
                <ButtonGroup>
                  <Button
                    type="primary"
                    onClick={() => getSnapshot()}
                    disabled={!hotelId || snapped}
                  >
                    Capturar
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
        </Spin>
      </Content>
    </Layout>
  );
};

export default ItemActionsSnapshot;
